<template>
  <main class="account" :class="{ 'account--hide-image': hideImage }">
    <section class="account__column account__column--cta">
      <div class="heading-container">
        <h1>
          {{ $t('pages.requestPasswordReset.header') }}
        </h1>
        <h4>{{ $t('pages.requestPasswordReset.textRequestEmail') }}</h4>
      </div>

      <form @submit.prevent="requestPasswordReset(email)">
        <BaseAlert
          v-model="showAlert"
          :variant="alert.type"
          :title="alert.title"
          data-cy="alert-account-disabled"
          :dismissible="true"
          class="u-margin-bottom-4x"
        >
          {{ alert.text }}
        </BaseAlert>
        <div class="form-group u-margin-bottom-4x">
          <input
            v-model.trim="email"
            class="form-control"
            type="text"
            :placeholder="$t('common.labelEmail')"
            :disabled="isLoading"
          />
        </div>
        <BaseButton
          class="u-margin-bottom-4x"
          full-width
          :loading="isLoading"
          type="submit"
        >
          {{ $t('pages.requestPasswordReset.buttonSendEmail') }}
        </BaseButton>
      </form>

      <BaseButton to="/login" variant="link">
        {{ $t('common.linkBackToLogin') }}
      </BaseButton>
    </section>

    <section class="account__column account__column--showcase">
      <img src="/img/login.svg" />
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ResetPasswordService from '@/common/services/ResetPassword';
import { whitelabel } from '@te/cdev-utils';

import { BaseAlert, BaseButton } from '@te/cdev-design-system';

export default defineComponent({
  metaInfo() {
    return {
      title: this.$t('pages.requestPasswordReset.title')
    };
  },
  components: {
    BaseAlert,
    BaseButton
  },
  data() {
    return {
      email: '',
      alert: {
        type: 'success',
        title: '',
        text: ''
      },
      showAlert: false,
      isLoading: false,
      hideImage: whitelabel('hideLoginImage')
    };
  },
  methods: {
    async requestPasswordReset(email: string) {
      this.isLoading = true;
      try {
        await ResetPasswordService.requestPasswordReset(email);
        this.alert = {
          type: 'success',
          title: this.$t('common.success'),
          text: this.$t('pages.requestPasswordReset.alertResetEmailSentSuccess')
        };
      } catch {
        this.alert = {
          type: 'error',
          title: this.$t('common.error'),
          text: this.$t('pages.requestPasswordReset.alertResetEmailSentFailure')
        };
      }
      this.showAlert = true;
      this.isLoading = false;
    }
  }
});
</script>
